import React from 'react';
import TradingLoader from './TradingLoader';
import './Spinner.scss';

export default function Spinner() {
  return <div className="showbox"><TradingLoader /></div>;
}
